Pegasus.BaseState = Ember.State.extend({
  unhandledEvent: function( /*manager, eventName*/ ) {
    //console.log("Pegasus.StateMachine got an unhandledEvent with name " + eventName);
  },

  setup: function( manager, context ) {
    manager.set('context', context);
  },
  didSave: function(manager){
    Pegasus.stateMachine.transitionTo('saved');
  },
  success: function(){
    Pegasus.stateMachine.transitionTo('saved');
  },

  gotoValidating: function(manager){
    manager.transitionTo('validating.confirming');
  }

});
